import * as AUTH_SERVICES from "api/services/auth/auth.services";
import React, { FC, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetProfileTeacherQuery } from "store/services/teacher/profileTeacher";

//!COMPONENTS
import { UserRoles } from "common/enums";
import AppDrawer from "components/appDrawer";
import AboutProfileTeacher from "screens/teacher/profileTeacher/components/about";
import HeaderProfileTeacher from "screens/teacher/profileTeacher/components/header";

type Props = {
  profId: string;
  openDrawerProfileTeacher: boolean;
  setOpenDrwerProfileTeacher: React.Dispatch<React.SetStateAction<boolean>>;
};

const DrawerProfileTeacher: FC<Props> = ({
  profId,
  openDrawerProfileTeacher,
  setOpenDrwerProfileTeacher,
}) => {
  //!HOOKS
  const params = useParams<"id">();
  const { user, idTeacher } = useSelector((state) => state.auth);

  const query = useMemo(() => {
    const profId = params.id ?? (user?.roles?.includes("teacher") ? user._id : undefined);
    const studId = user?._id ?? params.id;
    return { profId, studId };
  }, [params.id, user]);
  const { data, isLoading, isError } = useGetProfileTeacherQuery(query, {
    skip: !query.profId,
  });

  const [teacherData, setTeacherData] = useState<any>();

  const getTeacherData = async (teacherId: string) => {
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
      setTeacherData(response?.data);
    } catch (error: any) { }
  };

  useEffect(() => {
    if (profId) {
      getTeacherData(profId);
    }
  }, [profId]);

  return (
    <AppDrawer
      title={false}
      visible={openDrawerProfileTeacher}
      onClose={() => setOpenDrwerProfileTeacher(false)}
    >
      <HeaderProfileTeacher
        teacher={teacherData}
        alreadyFollowed={user?.roles?.includes(UserRoles.TEACHER) ? false : data?.data?.alreadyFollowd}
        followsNumber={user?.roles?.includes(UserRoles.TEACHER) ? "0" : data?.data?.followsNum}
      />
      <AboutProfileTeacher teacher={data?.data} />
    </AppDrawer>
  );
};

export default DrawerProfileTeacher;
